export const delay = (ms: number = 500): Promise<void> => new Promise((res) => setTimeout(res, ms));
